import { render, staticRenderFns } from "./PinsMatchingPreviousForm.vue?vue&type=template&id=18eab7ee"
import script from "./PinsMatchingPreviousForm.vue?vue&type=script&lang=ts"
export * from "./PinsMatchingPreviousForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports